import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpService {
  private options: any;
  constructor(private http: HttpClient) {
    this.options = {};
    this.options.headers = new HttpHeaders();
    this.options.headers = this.options.headers.append('Content-Type', 'application/json');
    this.options.headers = this.options.headers.append('Access-Control-Allow-Origin', '*');
  }

  public get(url: string, options?: any): Observable<any> {
    return this.http.request('get', url, options || {})
  }

  public post(url: string, body: any, options?: any): Observable<any> {
    return this.http.post(url, body, options);
  }

  public put(url: string, body: any, options?: any): Observable<any> {
    return this.http.put(url, body, options);
  }

  public delete(url: string, body?: any, options?: any): Observable<any> {
    const opts = {
      ...options,
      body,
      headers: (options?.headers ?? this.options.headers)
    };
    return this.http.request('DELETE', url, opts);
  }
}
